import { Component } from "@angular/core";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { MaskEmail } from "@edp-utils/mask-email.util";
import { Store, select } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "eligibility-delay",
    templateUrl: "./eligibility-delay.component.html",
    styleUrls: ["./eligibility-delay.component.scss"],
})
export class EligibilityDelayComponent {
    public email: string;
    public isPage: boolean;

    constructor(
        private edpPaymentAgreementService: EdpPaymentAgreementService, 
        private store: Store<IAppState>, 
        private readonly translateService: TranslateService,
        private readonly modalService: NewModalService,
    ) {
        this.email = this.edpPaymentAgreementService.getContactResponse()?.contact.email;
        this.isPage = this.edpPaymentAgreementService.getBottomBarValue();

        if (!this.email) {
            this.store.pipe(select(getUser)).subscribe(user => {
                if (user) {
                    this.email = MaskEmail.mask(user.email);
                }
            });
        }
    }

    public close() {
        if (this.isPage) {
            this.goToRequestAndOperations();
        } else {
            this.goToExternalUrl();
        }
    }

    public goToRequestAndOperations() {
        this.modalService.closeModal();
    }

    public goToExternalUrl() {
        const url = this.translateService.instant("pt.edp.edponline.payment.agreement.url.edp");
        window.location.href = url;
    }
}
